import experiments from '../../common/constants/experiments'

export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  experiments_to_features: {
    [experiments.themeforestSalePage]: {
      0: {
        salePage: false
      },
      1: {
        salePage: false
      },
      2: {
        salePage: true
      },
      3: {
        salePage: true
      }
    }
  },
  features: {
    salePage: false,
    'salePage:enrolment': true,
    'item-preview-with-carousel': true
  },
  assets_domains: {
    item_thumbnail: 'thumb-tf.s3.envato.com',
    item_image: 'image-tf.s3.envato.com'
  },
  feeds_categories: [
    '/category/wordpress',
    '/category/site-templates',
    '/category/marketing',
    '/category/cms-themes',
    '/category/ecommerce',
    '/category/muse-templates',
    '/category/sketch-templates',
    '/category/psd-templates',
    '/category/blogging',
    '/category/courses',
    '/category/forums',
    '/category/typeengine-themes'
  ],
  show_category_in_selected_filters: true
}
